// extracted by mini-css-extract-plugin
export default {"container":"components-loader-styles__container--jc_5C","in":"components-loader-styles__in--u5AXt","spinner":"components-loader-styles__spinner--YIt5r"};